<template>
  <div>
    <div v-if="success" class="mt-2">
      <b-card class='credit_card-form'>
        <div class='d-flex align-items-center'>
          <p>Compra efetuada com sucesso!</p>
          <b-icon icon='check-circle' class='mb-3 ml-2' variant='success' font-scale='1.5'></b-icon>

        </div>
        <router-link
          active-class='link-clicked'
          class='subMenuItem'
          :to="{ name: 'Colaboradores' }"
        >

          <span class='label'>Ir para meus colaboradores</span>
        </router-link>
      </b-card>
    </div>
    <div v-else>
      <div class="confirmation mt-2" v-if="!disabled">
        <div v-if="lr != 0 && payment.method == 'credit_card'" class="alert-purchase-refused pulse-alert-purchase-refused">
          <h3 class="text-center">Tentativa de pagamento não foi bem-sucedida</h3>
          <p>
            <strong>Descrição:</strong><br/>
            <span> {{descriptionLr}}</span>
          </p>

          <p>
            <strong>O que fazer agora?</strong><br/>
            <span> Verifique os dados do cartão ou tente outro método de pagamento.</span>
          </p>

          <p>
            <span>
              Em breve nossa equipe entrará em contato com você via Whatsapp para auxiliar no processo de adesão.
            </span>
          </p>
        </div>
        <div class="billing-data" v-if="billingData">
          <h2>Confirme abaixo os dados para finalizar a sua compra:</h2>
          <div class="groups">
            <div class="group">
              <h3>Dados do contratante</h3>
              <span v-if="billingData.name">
                <strong>Nome: </strong>
                {{billingData.name}}
              </span>
              <span v-if="billingData.document">
                <strong>CPF: </strong>
                {{billingData.document}}
              </span>
              <span v-if="billingData.email">
                <strong>Email: </strong>
                {{billingData.email}}
              </span>
              <span v-if="billingData.companyName">
                <strong>Nome da empresa: </strong>
                {{billingData.companyName}}
              </span>
              <span v-if="billingData.cnpj">
                <strong>CNPJ: </strong>
                {{billingData.cnpj}}
              </span>
              <span v-if="billingData.stateRegister">
                <strong>Inscrição estadual: </strong>
                {{billingData.stateRegister}}
              </span>
              <span v-if="billingData.cityRegister">
                <strong>Inscrição municipal: </strong>
                {{billingData.cityRegister}}
              </span>
            </div>
            <div class="group">
              <h3>Endereço do contratante</h3>
              <span v-if="billingData.address.street && billingData.address.number">
                <strong>Rua: </strong>
                {{billingData.address.street}},
                {{billingData.address.number}}
              </span>
              <span v-if="billingData.address.complement">
                <strong>Complemento: </strong>
                {{billingData.address.complement}}
              </span>
              <span v-if="billingData.address.neighborhood">
                <strong>Bairro: </strong>
                {{billingData.address.neighborhood}}
              </span>
              <span v-if="billingData.address.city">
                <strong>Cidade: </strong>
                {{billingData.address.city}}
              </span>
              <span v-if="billingData.address.state">
                <strong>Estado: </strong>
                {{billingData.address.state}}
              </span>
              <span v-if="billingData.address.cep">
                <strong>CEP: </strong>
                {{billingData.address.cep}}
              </span>
            </div>
          </div>
        </div>
        <div class="payment" v-if="payment">
          <h2>Dados de Pagamento</h2>
          <span v-if="payment.method">
            <strong>Método: </strong>
            {{methods[payment.method]}}
          </span>
          <span class="payment-method-notes">
            <template v-if="payment.method == 'credit_card'">
             <span>
              O acesso à plataforma HO Fácil Web é liberado automaticamente assim que o pagamento
              é aprovado pela operadora do cartão. Esse processo pode levar até <strong>15 minutos</strong>.
             </span>
            </template>
            <template v-else>
              <strong >
                Pagamento via PIX:
              </strong>
              <span>
                O acesso à plataforma HO Fácil Web é liberado automaticamente em até 30 minutos após a confirmação do pagamento.
              </span>
            </template>
          </span>
        </div>

        <div class="mt-2">
          <base-alert2
            v-if="alert.open"
            class="alert"
            :type="alert.type"
            :message="alert.message"
            @close="alert.open = false"
          />
        </div>

        <div class="buttons">
          <base-button
            block
            dark
            @click="back()"
          >
            Voltar
          </base-button>
          <base-button
            block
            @click="submitCheckout"
            :disabled="disabled"
          >
            Finalizar Compra
          </base-button>
        </div>
      </div>
      <div class="process-purchase" v-else>
        <div class='d-flex justify-content-end flex-column align-items-center'>
          <div class='mb-3'>
            <h5 v-if="tentativa === 1"><strong>Aguarde enquanto estamos tentando processar seu pagamento.</strong></h5>
            <h5 v-else-if="tentativa === 2"><strong>Estamos tendo lentidão ao processar pagamento, por favor, aguarde mais um pouco.</strong></h5>
            <h5 v-else><strong>Por favor, aguarde mais um pouco</strong></h5>
          </div>

          <div >
            <b-spinner style="width: 4rem; height: 4rem; font-size: 30px" variant="info"></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getLr } from '../../../utils/getLr'

export default {
  name: 'ConfirmationAccess',
  computed: {
    ...mapGetters('checkoutAccess', {
      billingData: 'getBillingData',
    }),
    ...mapGetters('checkout2', {
      payment: 'getPayment',
      alert: 'getAlertDetails'
    }),
    user() {
      return this.$store.getters['user/current']
    },
  },
  data(){
    return {
      disabled: false,
      success: false,
      descriptionLr: '',
      lr: 0,
      tentativa: 0,
      invoice: Object,
      charge: Object,
      methods: {
        'credit_card': 'Cartão de crédito',
        'bank_slip': 'PIX',
      },
      previousComponent: 'Payment',
    }
  },
  methods: {
    ...mapActions('checkout2', {
      handleSetAlertDetails: 'handleSetAlertDetails',
      handleResetAlertDetails: 'handleResetAlertDetails',
      handleResetSteps: 'handleResetSteps',
      handleResetPayment: 'handleResetPayment',
      handleResetBillingData: 'handleResetBillingData',
      handleResetPromotion: 'handleResetPromotion',
    }),
    ...mapActions('checkoutAccess', {
      handleSetToken: 'handleSetToken',
      handleSubmitCheckout: 'handleSubmitCheckout'
    }),
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs',
    }),
    back(){
      this.$emit('back-step')
      this.$emit('set-component', this.previousComponent)
    },
    async submitCheckout(){
      try{
        this.disabled = true
        this.success = false
        this.tentativa++;
        const { method, data } = this.payment
        const response = await this.handleSubmitCheckout({ method, installments: data.installments })
        this.lr = 0;
        if (response.errors) {
          const errorRaw = response.errors
          let error = errorRaw || 'Dados inválidos, verifique e tente novamente!'

          if(errorRaw['payer.address.zip_code'] || errorRaw['zip_code']){
            error = 'CEP inválido, verifique e tente novamente!'
          }

          if(errorRaw['payer.cpf_cnpj'] || errorRaw['cpf_cnpj']){
            error = 'CPF/CNPJ inválido, verifique e tente novamente!'
          }

          if(errorRaw['plan_identifier']){
            error = 'Plano inválido, verifique e tente novamente!'
          }

          if(errorRaw['token'] || errorRaw === 'Esse token já foi usado.' || errorRaw === 'This token has already been used'){
            error = 'Por favor preencha os dados do cartão novamente'
            this.$emit('back-step')
          }

          await this.handleSetAlertDetails({
            open: true,
            type: 'danger',
            message: error
          })
          this.disabled = false;
        } else {
          const {invoice, chargeMadeSuccessfully, charge} = response
          this.invoice = invoice
          if (chargeMadeSuccessfully) {
            if(this.payment.method == 'bank_slip' || (invoice && invoice.status && invoice.status == 'paid')){
              await this.handleSetAlertDetails({
                open: true,
                type: 'success',
                message: 'Pedido efetivado com sucesso!'
              })

              if (invoice && invoice.id) {
                window.open(invoice.secure_url, '_blank', "noopener,noreferrer")
                const novaRota = this.$router.resolve({
                  name: 'RedirectInvoice',
                  query: { id: invoice.id }
                });
                window.open(novaRota.href, '_blank');
              }
              this.disabled = false;
              this.success = true
              return
            }

            let lr = null;
            if (charge && charge.LR){
              lr = charge.LR;
            } else if (invoice && invoice.lr){
              lr = invoice.lr;
            } else if (invoice && invoice.LR){
              lr = invoice.LR;
            } else if (invoice && invoice.credit_card_transaction && invoice.credit_card_transaction.lr){
              lr = invoice.credit_card_transaction.lr;
            } else if (invoice && invoice.credit_card_transaction && invoice.credit_card_transaction.LR){
              lr = invoice.credit_card_transaction.LR;
            }
            if(!lr && invoice && invoice.logs && invoice.logs.length > 0){
              for (const log of invoice.logs) {
                const {notes} = log
                if(!notes){
                  continue
                }
                const notesSplit = notes.toString().split(',')

                if(!notesSplit || notesSplit.length <= 0){
                  continue
                }

                const lrLog = notesSplit.find(x => x && x.toString().toUpperCase().trim().includes('LR'))
                if(!lrLog){
                  continue
                }

                const lrLogSplit = lrLog.split(':')

                if(!lrLogSplit || lrLogSplit.length <= 1){
                  continue
                }
                lr = lrLogSplit[1].trim()
              }
            }
            this.lr = lr
            this.descriptionLr = getLr(lr)
          } else {
            await this.handleSetAlertDetails({
              open: true,
              type: 'danger',
              message: 'Não foi possível processar seu pagamento, tente novamente mais tarde!!'
            })
          }
          this.disabled = false;
        }
      } catch(error) {
        console.log(error)
        if(this.tentativa < 3) {
          setTimeout(async () => {
            await this.submitCheckout();
          }, 22500)
        } else {
          this.disabled = false;
          this.tentativa = 0;
          await this.handleSetAlertDetails({
            open: true,
            type: 'danger',
            message: 'Não foi possível processar seu pagamento, tente novamente mais tarde!!!'
          })
        }
      } finally {
        //this.disabled = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-spinner{
  width: 2.5rem;
  height: 2.5rem;
  margin: -15px 0 0 10px;
}
.confirmation {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    font-size: 22px;
    font-weight: 700;
  }
  h3 {
    font-size: 18px;
    font-weight: 700;
  }
  .billing-data, .payment, .group {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .billing-data {
    .groups {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
    }
  }
  .buttons {
    display: flex;
    gap: 16px;
  }
  .payment-method-notes {
    font-size: 15px;
  }
  .alert-purchase-refused{
    margin-top: 10px;
    background: rgba(248, 215, 218, 1);
    padding: 10px 15px;
    h3{
      font-weight: 700;
      font-size: 20px;
      color: #721C24;
    }
    strong{
      font-weight: 700;
      font-size: 16px;
      color: #262626;
    }
    span{
      font-weight: 400;
      font-size: 14px;
      color: #721C24;
    }
  }
}

.process-purchase{
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse-alert-purchase-refused {
  -webkit-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #721C24;
  border-radius: 3px;
  margin-bottom: 3px!important;
  margin-top: 3px!important;
}



@-webkit-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

</style>
